import axios from 'axios';

import {
    BASE_URL
} from '../../config';

import security from '../../components/common/security/security';
import delivery from '../../components/delivery/delivery';
import  { ACTION_TYPES } from '../../config/constants';

export const login = (user, cb) => {
    return (dispatch) => {
        axios.post(`${BASE_URL}auth/login`, {
                username: user.username,
                password: user.password
            })
            .then(function (response) {
                const payload = response.data;
                security.login(payload.token, payload);
                delivery.setSessionId(payload.sessionId);
                delivery.setRoomId(payload.roomId);
                delivery.start(payload.sessionId);
                dispatch({
                    type: ACTION_TYPES.LOGIN_SUCCESS,
                    token: payload.token
                });
                cb(payload);
            });
    }
};

export const logout = (cb) => {
    return (dispatch) => {
        security.logout();
        delivery.stop();
        if('function' === typeof dispatch){
            dispatch({
                type: ACTION_TYPES.LOGOUT_SUCCESS
            });
        }
        if ('function' === typeof cb) {
            cb();
        }
    };
};